import {useMutation, UseMutationOptions} from '@tanstack/react-query'
import {MUTATION_KEYS} from '@/queryClient'
import {httpDeleteProject} from '@/features/projects/http/projects.http'

export const useDeleteProject = (projectId: string, options?: Omit<UseMutationOptions, 'mutationFn'>) =>
    useMutation({
        mutationKey: [MUTATION_KEYS.DELETE_PROJECT],
        mutationFn: () => httpDeleteProject({urlParams: {projectId}}),
        ...options
    })
